module.exports = __webpack_public_path__ + "static/media/semaforo.d80dd623.svg";